import React, { useState } from 'react'
import { HorizontalTabs, TabConfig } from '../../../Component/EnhancedData/HorizontalTabs'
import { EnhancedDataPageTemplate, TemplateProps } from '../EnhancedDataPageTemplate'
import { ViewTransactions } from './ViewTransactions'

const self = Symbol('ViewEnhancedDataTransactions')
const PAGE_TITLE: string = 'L2/L3 Transactions'

type TransactionTabType = 'required' | 'optional' // represent type and unique tabIds at the same time

export function ViewEnhancedDataTransactions (): React.JSX.Element {
  const [responseFeedback, setResponseFeedback] = useState('')

  const [activeTabId, setActiveTabId] = useState<TransactionTabType>('required')
  const onTabChangeHandler = (currentTabId: TransactionTabType): void => {
    setActiveTabId(currentTabId)
  }

  const templateProps: TemplateProps = {
    title: PAGE_TITLE,
    redirectUrl: '',
    symbol: self,
    responseMessage: responseFeedback,
    // TODO: May need to implement these handlers down the road
    // networkErrorHandler: defaultNetworkErrorHandler,
    // networkSuccessHandler: (message: string) => {
    //   createNetworkError()
    //   setResponseFeedback(message)
    // },
  }

  // Define Tab configuration by tabId
  const tabsConfig: Record<TransactionTabType, TabConfig> = {
    required: {
      title: 'Required',
      content: <ViewTransactions symbol={self} isEnhancedDataRequired={true}/>,
    },
    optional: {
      title: 'Optional',
      content: <ViewTransactions symbol={self} isEnhancedDataRequired={false}/>,
    },
  }

  return (
    <EnhancedDataPageTemplate { ...templateProps }>
      <HorizontalTabs
        activeTabId={ activeTabId }
        onTabChange={ onTabChangeHandler }
        tabs={ tabsConfig }
      />
    </EnhancedDataPageTemplate>
  )
}
